import * as React from "react";

import "./advance-form.scss";

import {bindInput}          from "@Common/react/bind-input";
import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {DebounceCache}      from "@Common/react/debounce-cache";
import {scopedState}        from "@Common/react/scoped-state";
import {SliderCheckbox}     from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {equalDeep}          from "@Common/utils/objects";
import {DateRangePicker}    from "@Xpresso/routes/common/date-range-picker/date-range-picker";
import {
    USER_LEVEL,
    BRANCH_LEVEL,
    COMPANY_LEVEL}          from "@Xpresso/routes/common/logic/user-level";



const OFFICE_ORDERS_ONLY = 'Only Show Office Orders'

export const AdvanceForm = ({tags, forceSearchable, onClose, isMobile=false}) => cs(
    consumeContext("userLevels"),
    ["debounce", (_, next) => DebounceCache({
        state: tags,
        next,
    })],
    ({userLevels, debounce}) => (
        <div className="advance-form advance-form-4o5">
            <div className="main">
                <div className="title">
                    Advanced Search
                </div>
                <div className="content">
                    {fields.map(v => (
                        !(userLevels.userLevel > COMPANY_LEVEL && v.type == "branchName") &&
                        !(userLevels.userLevel > BRANCH_LEVEL && v.type == "agentName") &&
                        <input
                            className="search-field"
                            key={v.type}
                            placeholder={v.placeholder}
                            {...bindInput({
                                value: debounce.state.value[v.type],
                                onChange: e => {
                                    if (e.trim() !== "") {
                                        debounce.state.onChange({...debounce.state.value, [v.type]: e});
                                    }
                                    else if (e === "") {
                                        debounce.state.onChange({...debounce.state.value, [v.type]: undefined});
                                    }
                                },
                            })}
                            onBlur={() => debounce.flush()}
                            xd-qa-type="field"
                            xd-qa-name={v.type}
                        >
                        </input>
                    ))}
                    {userLevels.userLevel < USER_LEVEL &&
                        (() => {
                            const officeOrderDisplay = 'Office Order'
                            const isBranchOrder = debounce.state.value['isBranchOrder'] === officeOrderDisplay
                            const toggleBranchOrder = isBranchOrder ? null : officeOrderDisplay
                            return (
                                <div className="office-order-toggle">
                                    {
                                        SliderCheckbox({
                                            value: isBranchOrder,
                                            xdQaName: "Show Branch Orders",
                                            onChange: () => debounce.state.onChange({
                                                ...debounce.state.value,
                                                'isBranchOrder': toggleBranchOrder
                                            }),
                                        })
                                    }
                                    {OFFICE_ORDERS_ONLY}
                                </div>
                            )
                        })()
                    }
                    {DateRangePicker({
                        startDate: scopedState(debounce.state, ["startDate"]),
                        endDate  : scopedState(debounce.state, ["endDate"]),
                    })}
                </div>
            </div>
            <div className="footer">
                <button
                    className="cancel"
                    onClick={onClose}
                    xd-qa-type="button"
                    xd-qa-name="cancel"
                >
                    Cancel
                </button>

                <button
                    className="search"
                    onClick={() => {
                        onClose();
                    }}
                    disabled={
                        equalDeep(debounce.state.value, {
                            all: [],
                            orderName: null,
                            orderId: null,
                            cartId: null,
                            poNumber: null,
                            startDate: null,
                            endDate: null,
                        }) && !forceSearchable
                    }
                    xd-qa-type="button"
                    xd-qa-name="search"
                >
                    Search
                </button>
            </div>
        </div>
    ),
);

const fields = [
    {
        type: "orderName",
        placeholder: "Order Name"
    },
    {
        type: "orderId",
        placeholder: "Order ID"
    },
    {
        type: "cartId",
        placeholder: "Cart ID"
    },
    // {
    //     type: "order_meta",
    //     placeholder: "Billing Field"
    // },
    {
        type: "agentName",
        placeholder: "User Name"
    },
    {
        type: "branchName",
        placeholder: "Office Name"
    },
];
